import { Camera } from './../_shared/models/camera.model';
import { Match } from '../_shared/models/match.model';
import { ToastService } from '../_core/services/toast.service';
import { ModalController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { VideoStreamProviderService } from './video-stream-provider.service';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-video-stream-provider-list',
  templateUrl: './video-stream-provider-list.component.html',
  styleUrls: ['./video-stream-provider-list.component.scss'],
})
export class VideoStreamProviderListComponent implements OnInit {
  private modalController = inject(ModalController);
  private toastService = inject(ToastService);
  private videoStreamProviderService = inject(VideoStreamProviderService);
  private translateService = inject(TranslateService);

  @Input() playsightLink = 'https://a-link-that-is-needed-for-playsight-camera';
  @Input() match: Match;

  videoStreamProviderList: any;
  token: string;
  showAddCamera = false;
  microframeCameras: Camera[];
  tracktennisCameras: Camera[];
  playsightCameras: Camera[];
  saveMyPlayCameras: Camera[];

    async ngOnInit() {
      this.getVideoStreamProviderList();       
    }

    async copyLink() {
      await Clipboard.write({ string: this.playsightLink });
      this.toastService.presentToast(this.translateService.instant('Link is copied to the clipboard'));
    }

    close() {
      this.modalController.dismiss();
    }

    getVideoStreamProviderList() {
      this.videoStreamProviderService
        .getVideoStreamProviderList()
        .pipe(take(1))
        .subscribe(
          async res => {
            this.videoStreamProviderList = res.data;
            this.tracktennisCameras = this.getPartnerCamera('tracktennis');
            this.microframeCameras = this.getPartnerCamera('microframe');
            this.playsightCameras = this.getPartnerCamera('playsight');
            this.saveMyPlayCameras = this.getPartnerCamera('savemyplay');
            this.showAddCamera = false;            
          }
        )
  
    }

    saveToken() {
      this.videoStreamProviderService
        .updateCameras('tracktennis', this.token)
        .pipe(
          take(1)
        )
        .subscribe({
          next: async res => {
            this.getVideoStreamProviderList()
          }
        })
    }

    private getPartnerCamera(partner: string): Camera[] {      
      return this.match.cameras.filter(c => c.partner === partner)
    }

    removeCamera(camera: Camera, index: number) {
      this.videoStreamProviderService
        .removeCamera(camera, this.match._id)
        .pipe(take(1))
        .subscribe({
          next: res => {
            if (camera.partner === 'microframe') {
              this.microframeCameras.splice(index, 1);
              this.handleRemoveCamera('microframe')
            } else if (camera.partner === 'tracktennis') {
              this.tracktennisCameras.splice(index, 1);
              this.handleRemoveCamera('tracktennis')
            }

            this.toastService.presentToast(this.translateService.instant(res.message));

          }
        })
    }

    private handleRemoveCamera(partner) {
      const camIndex = this.match.cameras.findIndex(c => c.partner === partner);
      this.match.cameras.splice(camIndex, 1);
    }

    removeFacility(facility) {      
      this.videoStreamProviderService
        .removeFacility(facility.videoStreamSettingsId)
        .pipe(take(1))
        .subscribe({
          next: res => {
            const index = this.videoStreamProviderList.findIndex(f => f.videoStreamSettingsId === facility.videoStreamSettingsId);
            this.videoStreamProviderList.splice(index, 1)
            this.toastService.presentToast(this.translateService.instant(res.message));
          }
        })
    }

}
